module.exports = __webpack_public_path__ + "img/pet_power.1adada62.png";